<template>
  <div
    ref="readerContainer"
    class="colibrio-reader-container"
  />
</template>

<script>
import { loadColibrioScript, getColibrioConfig, buildEpubKey } from '@/helpers/colibrioHelper';

export default {
  name: 'ColibrioCirrusReader',
  props: {
    bookId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    unencryptedFilePath: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      cirrusReader: null,
    };
  },
  async mounted() {
    try {
      await loadColibrioScript();
      this.initializeReader();
    } catch (error) {
      this.$emit('error', error);
    }
  },
  beforeDestroy() {
    if (this.cirrusReader) {
      this.cirrusReader.destroy?.();
    }
  },
  methods: {
    initializeReader() {
      const config = getColibrioConfig();
      const epubKey = buildEpubKey(this.bookId, this.unencryptedFilePath);

      this.cirrusReader = new window.CirrusReader({
        container: this.$refs.readerContainer,
        clientId: config.clientId,
        configVersion: config.configVersion,
        config: {
          user: this.userId,
          publication: {
            key: epubKey,
          },
        }
      });

      this.cirrusReader.addEventListener?.('readerLoaded', () => {
        this.$emit('loaded');
      });

      this.cirrusReader.addEventListener?.('readerDestroyed', () => {
        this.$emit('destroyed');
      });

      this.cirrusReader.initialise('100%');
    },
  },
};
</script>

<style scoped>
.colibrio-reader-container {
  width: 100%;
  height: 100%;
  min-height: 500px;
}
</style>
